import { render, staticRenderFns } from "./RegisterDataLampiran.vue?vue&type=template&id=db156006&scoped=true&"
import script from "./RegisterDataLampiran.vue?vue&type=script&lang=js&"
export * from "./RegisterDataLampiran.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDataLampiran.vue?vue&type=style&index=0&id=db156006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db156006",
  null
  
)

export default component.exports